import { html } from 'lit';
import { MoreHorizontal } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-more-horizontal')
export class PdsIconMoreHorizontal extends PdsIcon {
  @state()
  icon = MoreHorizontal;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
